/* global define */

define([], () => ({
  UPDATE_CAMPAIGNS_SETTING: 'UPDATE_CAMPAIGNS_SETTING',

  REQUEST_SETTINGS: 'REQUEST_SETTINGS',
  RECEIVE_SETTINGS: 'RECEIVE_SETTINGS',
  ERROR_SETTINGS: 'ERROR_SETTINGS',
  UPDATE_SETTING: 'UPDATE_SETTING',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',

  REQUEST_CAMPAIGN: 'REQUEST_CAMPAIGN',
  RECEIVE_CAMPAIGN: 'RECEIVE_CAMPAIGN',
  ERROR_CAMPAIGN: 'ERROR_CAMPAIGN',

  REQUEST_CAMPAIGNS: 'REQUEST_CAMPAIGNS',
  RECEIVE_CAMPAIGNS: 'RECEIVE_CAMPAIGNS',
  ERROR_CAMPAIGNS: 'ERROR_CAMPAIGNS',
  RESET_CAMPAIGN_ERRORS: 'RESET_CAMPAIGN_ERRORS',

  // A universal action called on all requests.
  VALIDATE: 'VALIDATE',

  UPDATE_CAMPAIGN_TEXT_FILTER: 'UPDATE_CAMPAIGN_TEXT_FILTER',
  RECEIVE_CAMPAIGN_STATS: 'RECEIVE_CAMPAIGN_STATS',
  UPDATE_ACTIVE_CAMPAIGN: 'UPDATE_ACTIVE_CAMPAIGN',
  UPDATE_RETURN_VIEW_SETTING: 'UPDATE_RETURN_VIEW_SETTING',

  RECEIVE_AND_SET_ACTIVE_CAMPAIGN: 'RECEIVE_AND_SET_ACTIVE_CAMPAIGN',

  REQUEST_CAMPAIGN_SEND_TEST: 'REQUEST_CAMPAIGN_SEND_TEST',
  RECEIVE_CAMPAIGN_SEND_TEST: 'RECEIVE_CAMPAIGN_SEND_TEST',
}));

